var toggleNonCompeteAreas = function toggleNonCompeteAreas() {
  var checkbox = document.getElementById('user_consultant_profile_attributes_has_non_compete_areas');
  var container = document.getElementById('non-compete-areas-container');
  if (checkbox && container) {
    if (checkbox.checked) {
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }
  }
};
document.addEventListener('DOMContentLoaded', function () {
  // Phone number masking (requires jQuery mask plugin)
  if (typeof $ !== 'undefined' && $.fn.mask) {
    $("input[name*='phone_number']").mask('(000) 000-0000');
  }

  // Hide filter lists initially
  var therapeuticsList = document.getElementById('therapeutics-list');
  var rolesList = document.getElementById('roles-list');
  var expertiseList = document.getElementById('expertise-list');
  if (therapeuticsList) therapeuticsList.style.display = 'none';
  if (rolesList) rolesList.style.display = 'none';
  if (expertiseList) expertiseList.style.display = 'none';
  toggleNonCompeteAreas();

  // Filter select change
  var filterSelect = document.getElementById('filter-select');
  if (filterSelect) {
    filterSelect.addEventListener('change', function (e) {
      var val = e.target.value;
      if (val === 'therapeutics-list') {
        if (therapeuticsList) therapeuticsList.style.display = 'block';
        if (rolesList) rolesList.style.display = 'none';
        if (expertiseList) expertiseList.style.display = 'none';
      } else if (val === 'expertise-list') {
        if (expertiseList) expertiseList.style.display = 'block';
        if (rolesList) rolesList.style.display = 'none';
        if (therapeuticsList) therapeuticsList.style.display = 'none';
      } else {
        if (rolesList) rolesList.style.display = 'block';
        if (expertiseList) expertiseList.style.display = 'none';
        if (therapeuticsList) therapeuticsList.style.display = 'none';
      }
    });
  }

  // Available now checkbox
  var availableNow = document.getElementById('available-now');
  var approximateStartDate = document.getElementById('approximate-start-date');
  if (availableNow) {
    availableNow.addEventListener('change', function () {
      if (typeof moment !== 'undefined' && approximateStartDate && approximateStartDate.pikaday) {
        if (availableNow.checked) {
          approximateStartDate.pikaday.setDate(moment().startOf('day').toDate());
        } else {
          approximateStartDate.pikaday.setDate(null);
        }
      }
    });
  }

  // Clear start date
  var clearStartDate = document.getElementById('clear-start-date');
  if (clearStartDate && availableNow) {
    clearStartDate.addEventListener('click', function (e) {
      e.preventDefault();
      availableNow.checked = false;
    });
  }

  // Non-compete areas toggle
  var nonCompeteCheckbox = document.getElementById('user_consultant_profile_attributes_has_non_compete_areas');
  if (nonCompeteCheckbox) {
    nonCompeteCheckbox.addEventListener('change', toggleNonCompeteAreas);
  }

  // Initialize Select2 for company select (requires jQuery and Select2)
  if (typeof $ !== 'undefined' && $.fn.select2) {
    var companySelects = $('.user-company-select');
    if (companySelects.length && !companySelects.first().hasClass('select2-enabled')) {
      companySelects.select2({
        theme: 'bootstrap',
        closeOnSelect: true,
        placeholder: 'Company',
        width: 'auto',
        tags: false
      });
      companySelects.addClass('select2-enabled');
    }
  }

  // Sync to Clorify
  document.querySelectorAll('.sync-to-clorify').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var resource = button.dataset.resource;
      fetch("/users/".concat(resource, "/sync_to_clorify"), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        alert("Sync queued for: ".concat(data.user));
      })["catch"](function () {
        alert('Could not queue sync job');
      });
    });
  });
});